'use strict';

import { getLoginRequiredResolveObj } from '../shared/utils/angularUtils';

export const notesModule = angular
  .module('app.notes', [])
  .config(notesConfig);

notesConfig.$inject = ['$routeProvider'];

function notesConfig($routeProvider) {
  $routeProvider
    .when('/coach-notes', {
      template: '<ngz-coach-notes></ngz-coach-notes>',
      resolve: getLoginRequiredResolveObj(),
    });
}
